import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  questionList: [],
  questionDetail: [],
  loading: false,
  error: undefined,
};

const questionSlice = createSlice({
  name: "question",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchQuestionList(state, action) {
      state.questionList = action.payload;
      state.loading = false;
    },
    fetchQuestionDetail(state, action) {
      state.questionDetail = action.payload;
      state.loading = false;
    },
  },
});

export const questionActions = questionSlice.actions;

export default questionSlice.reducer;
